import { apiClient } from "./apiClient";

/**
 * All export endpoints require the same auth headers as everything else,
 * so a plain `<a href="...">` can't be used (no way to attach a bearer
 * token to a browser-initiated navigation) -- fetch as a blob through
 * apiClient instead, then synthesize the download client-side.
 */
async function downloadBlob(path, params, fallbackFilename) {
  const response = await apiClient.get(path, { params, responseType: "blob" });
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename=([^;]+)/);
  const filename = match ? match[1].trim() : fallbackFilename;

  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const exportApi = {
  hivesCsv: (startDate, endDate) => downloadBlob("/export/hives/csv", { start_date: startDate, end_date: endDate }, "hives_export.csv"),
  hivesJson: () => apiClient.get("/export/hives/json").then((r) => r.data),
  // Your yards, with the address and coordinates. The hive export
  // names its site but cannot carry a site's own details without
  // repeating them on every row (#275, reported 27 Aug).
  sitesCsv: () => downloadBlob("/export/sites/csv", {}, "sites_export.csv"),
  clientsCsv: () => downloadBlob("/export/clients/csv", {}, "clients_export.csv"),
  transactionsCsv: (startDate, endDate) => downloadBlob("/export/transactions/csv", { start_date: startDate, end_date: endDate }, "transactions_export.csv"),
  treatmentsCsv: () => downloadBlob("/export/treatments/csv", {}, "treatments_export.csv"),
  feedingsCsv: () => downloadBlob("/export/feedings/csv", {}, "feedings_export.csv"),
  allZip: () => downloadBlob("/export/all/zip", {}, "my_data_export.zip"),
};
